import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Fleet Management';
  baseUrl = environment.baseUrl;
  httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json;charset=UTF-8',
  })};

  vehicles: any[];
  posting = false;
  newCapabilityFields = {};
  newContextFields = {};
  newProfileFields = {};
  expansions = {};
  newVehicleInput = '';

  constructor(private http: HttpClient, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.searchFleet();
  }

  editProfile(vehicleIndex, profileIndex): void {
    let selectedProfile;
    if (profileIndex == null) {
      const newProfileName = this.newProfileFields[vehicleIndex].name.trim();
      if (newProfileName.length === 0) {
        return;
      }
      this.newProfileFields[vehicleIndex].name = '';
      selectedProfile = {label: newProfileName, price: 0.0,
                          capabilities: JSON.parse(JSON.stringify(this.vehicles[vehicleIndex].capabilities))};
    } else {
      selectedProfile = this.vehicles[vehicleIndex].profiles[profileIndex];
      const capabilitiesMap = {};
      for (const capability of selectedProfile.capabilities) {
        capabilitiesMap[capability.label] = capability.enabled;
        for (const context of capability.contexts) {
          capabilitiesMap[capability.label + '-' + context.label] = context.enabled;
        }
      }
      selectedProfile.capabilities = JSON.parse(JSON.stringify(this.vehicles[vehicleIndex].capabilities));
      for (const capability of selectedProfile.capabilities) {
        capability.enabled = !!capabilitiesMap[capability.label];
        for (const context of capability.contexts) {
          context.enabled = !!capabilitiesMap[capability.label + '-' + context.label];
        }
      }
    }

    const dialogRef = this.dialog.open(ProfileEditorComponent, {
      data: selectedProfile
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null){
        if (profileIndex == null) {
          this.vehicles[vehicleIndex].profiles.push(result);
        } else {
          this.vehicles[vehicleIndex].profiles[profileIndex] = result;
        }
        this.updateFleet();
      }
    });
  }

  addCapability(vehicleIndex): void {
    const val = parseInt(this.newCapabilityFields[vehicleIndex].value, null);
    const name = this.newCapabilityFields[vehicleIndex].name.trim();
    if (name.length === 0 || isNaN(val)) {
      return;
    }
    this.vehicles[vehicleIndex].capabilities.push({label: name, value: val, contexts: [], enabled: false});
    if (this.newContextFields[vehicleIndex] == null) {
      this.newContextFields[vehicleIndex] = {};
    }
    this.newContextFields[vehicleIndex][this.vehicles[vehicleIndex].capabilities.length - 1] = {name: '', value: ''};
    this.newCapabilityFields[vehicleIndex].value = '';
    this.newCapabilityFields[vehicleIndex].name = '';
    this.updateFleet();
  }

  removeCapability(vehicleIndex, capabilityIndex): void {
    const capabilitiesList = this.vehicles[vehicleIndex].capabilities;
    for (let i = capabilityIndex + 1; i < capabilitiesList.length; ++i) {
      capabilitiesList[i - 1] = capabilitiesList[i];
    }
    capabilitiesList.pop();
    this.updateFleet();
  }

  addContext(vehicleIndex, capabilityIndex): void {
    const val = parseInt(this.newContextFields[vehicleIndex][capabilityIndex].value, null);
    const name = this.newContextFields[vehicleIndex][capabilityIndex].name.trim();
    if (name.length === 0 || isNaN(val)) {
      return;
    }
    this.vehicles[vehicleIndex].capabilities[capabilityIndex].contexts.push({label: name, value: val, enabled: false});
    this.newContextFields[vehicleIndex][capabilityIndex].value = '';
    this.newContextFields[vehicleIndex][capabilityIndex].name = '';
    this.updateFleet();
  }

  removeContext(vehicleIndex, capabilityIndex, contextIndex): void {
    const contextsList = this.vehicles[vehicleIndex].capabilities[capabilityIndex].contexts;
    for (let i = contextIndex + 1; i < contextsList.length; ++i) {
      contextsList[i - 1] = contextsList[i];
    }
    contextsList.pop();
    this.updateFleet();
  }

  changeFleet(add, vin): void {
    const vehicle = vin.trim().toUpperCase();
    if (vehicle.length === 0) {
      return;
    }

    let inList = false;
    for (let i = 0; i < this.vehicles.length; ++i) {
      if (inList) {
        this.vehicles[i - 1] = this.vehicles[i];
      } else if (this.vehicles[i].vin === vehicle) {
        inList = true;
        if (add) {
          break;
        }
      }
    }
    if (add) {
      this.vehicles.push({vin: vehicle, p2p: false, capabilities: [], lendee: null});
      this.newVehicleInput = '';
      this.newCapabilityFields[this.vehicles.length - 1] = {name: '', value: ''};
      this.newProfileFields[this.vehicles.length - 1] = {name: ''};
    } else if (inList) {
      this.vehicles.pop();
    }
    this.updateFleet();
  }

  searchFleet(): void {
    this.http.get(this.baseUrl + '/listfleet')
      .subscribe((response: Response) => {
        const result = response as any;
        if (result.error == null || result.error.length === 0) {
          for (let i = 0; i < result.vehicles.length; ++i) {
            this.newCapabilityFields[i] = {name: '', value: ''};
            this.newProfileFields[i] = {name: ''};
            this.newContextFields[i] = {};
            for (let e = 0; e < result.vehicles[i].capabilities.length; ++e) {
              this.newContextFields[i][e] = {name: '', value: ''};
            }
          }
          this.vehicles = result.vehicles;
        }
      });
  }

  updateFleet(): void {
    this.posting = true;

    this.http.post(this.baseUrl + '/updatefleet', this.vehicles, this.httpOptions)
      .subscribe((response: Response) => {
        this.posting = false;
        const result = response as any;
        if (result.error == null || result.error.length === 0) {
          this.vehicles = result.vehicles;
        }
      }, (error) => {
        console.log('Error: ' + error);
        this.posting = false;
      });
  }
}

@Component({
  selector: 'app-profile-editor-dialog-component',
  templateUrl: 'profile-editor-dialog.component.html',
})
export class ProfileEditorComponent {

  constructor(
    public dialogRef: MatDialogRef<AppComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  onCancel(): void {
    this.dialogRef.close();
  }

}
